/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: 7rG0DYfwVULy

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicLinkCard.module.css"; // plasmic-import: 7rG0DYfwVULy/css

createPlasmicElementProxy;

export type PlasmicLinkCard__VariantMembers = {};
export type PlasmicLinkCard__VariantsArgs = {};
type VariantPropType = keyof PlasmicLinkCard__VariantsArgs;
export const PlasmicLinkCard__VariantProps = new Array<VariantPropType>();

export type PlasmicLinkCard__ArgsType = { currentItem?: any };
type ArgPropType = keyof PlasmicLinkCard__ArgsType;
export const PlasmicLinkCard__ArgProps = new Array<ArgPropType>("currentItem");

export type PlasmicLinkCard__OverridesType = {
  root?: Flex__<"a"> & Partial<LinkProps>;
  freeBox?: Flex__<"div">;
};

export interface DefaultLinkCardProps {
  currentItem?: any;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLinkCard__RenderFunc(props: {
  variants: PlasmicLinkCard__VariantsArgs;
  args: PlasmicLinkCard__ArgsType;
  overrides: PlasmicLinkCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <PlasmicLink__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "a",
        "a__k4MoY",
        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      component={Link}
      href={(() => {
        try {
          return $props.currentItem.destiny ?? "/account";
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return "#";
          }
          throw e;
        }
      })()}
      legacyBehavior={false}
      platform={"nextjs"}
      style={(() => {
        try {
          return (() => {
            let a = $ctx.pagePath === $props.currentItem.destiny;
            let b = { backgroundColor: "rgba(0, 0, 0, 0.3)" };
            let c = {};
            return a ? b : c;
          })();
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      target={undefined}
    >
      <div className={classNames("all", "__wab_text", sty.text__icXsS)}>
        <React.Fragment>
          {(() => {
            try {
              return $props.currentItem.title;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "Cart";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        {(() => {
          try {
            return $props.currentItem.props.waiting_orders;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <div
            className={classNames("all", "__wab_text", sty.text__abQc9)}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.currentItem.props.waiting_orders;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "99";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        ) : null}
        {(() => {
          try {
            return $props.currentItem.props.pending;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <div
            className={classNames("all", "__wab_text", sty.text__oh2Jq)}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.currentItem.props.pending;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "99";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        ) : null}
        {(() => {
          try {
            return $props.currentItem.props.working_orders;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return false;
            }
            throw e;
          }
        })() ? (
          <div
            className={classNames("all", "__wab_text", sty.text__yrMxa)}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <React.Fragment>
              {(() => {
                try {
                  return $props.currentItem.props.working_orders;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "99";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </div>
        ) : null}
      </div>
    </PlasmicLink__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "a";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLinkCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLinkCard__VariantsArgs;
    args?: PlasmicLinkCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLinkCard__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLinkCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLinkCard__ArgProps,
          internalVariantPropNames: PlasmicLinkCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLinkCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLinkCard";
  } else {
    func.displayName = `PlasmicLinkCard.${nodeName}`;
  }
  return func;
}

export const PlasmicLinkCard = Object.assign(
  // Top-level PlasmicLinkCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicLinkCard
    internalVariantProps: PlasmicLinkCard__VariantProps,
    internalArgProps: PlasmicLinkCard__ArgProps
  }
);

export default PlasmicLinkCard;
/* prettier-ignore-end */
